module.exports = __webpack_public_path__ + "img/video-player/down-22df2d1cf2d312b657a09f7d2ac22874.png";